<template>
  <router-view />
</template>

<script>
export default {
  name: "app-typeCategory"
};
</script>

<style lang="scss" scoped></style>
